export default "__VITE_ASSET__eb2de48c__$_?component__"